export default "__VITE_ASSET__DrGzhCQ$__"